import React from "react";

const NotFound = () => {
  return (
    <div style={{ padding: "80px", textAlign: "center" }}>
      <h1 style={{ fontSize: "50px", color: "red" }}>404</h1>
      <h2>Page Not Found</h2>
      <p>You are not authorized to access this page.</p>
    </div>
  );
};

export default NotFound;
